module.exports = require('./helpers/bundle-url').getBundleURL('hSWUQ') + "logo-dark.eefe0b7f.svg";